module.exports = __webpack_public_path__ + "img/img4.653ffbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img4.png
// module id = 179
// module chunks = 0